import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 船舶关注 状态
 */
class State extends UltMeta {
    IN_FLIGHT = new Meta(1, "在航");
    ANCHOR = new Meta(2, "锚泊");
    BERTHING = new Meta(3, "靠泊");
}

export const STATE = new State();
